import React, { useState } from "react";
const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <p className="text">
            {isReadMore ? text.slice(0, 200) : text}
            <span
                onClick={toggleReadMore}
                className="read-or-hide moreless-button"
                style={{ color: "#c19968" }}
            >
                {isReadMore ? "...Read more" : " Show less"}
            </span>
        </p>
    );
};

export default function Readmorehome() {
    return (
        <div>
            <ReadMore>
            The Grand New Delhi, nestled in the heart of Delhi NCR, is a distinguished luxury hotel.
                The ideal destination for the discerning business and leisure traveller, our hotel boasts
                modern facilities in a resort-like setting with luscious greens & waterscape.
                The Grand New Delhi, nestled in the heart of Delhi NCR, is a distinguished luxury hotel.
                        The ideal destination for the discerning business and leisure traveller, our hotel boasts
                        modern facilities in a resort-like setting with luscious greens & waterscape.
            </ReadMore>
        </div>
    )
};